module.exports = __webpack_public_path__ + "img/doc-pdf-preview.39e44855.png";